/**
 * Shared helpers: which schools belong in "Schools Open To All".
 *
 * Pure Open category → always.
 * Both (priority + open) → only when the policy states a positive open-seat
 * quota (e.g. KEGS 30, Sutton 75). An Open band with null seats (Tiffin /
 * HBS residual “outside priority”) does not qualify — those stay out of the
 * list; explain practical reality via catchment panel note instead.
 */

export function hasStatedOpenSeatQuota(school) {
  if (!school) return false;
  const n = Number(school.open_alloc_seats);
  if (Number.isFinite(n) && n > 0) return true;
  const disp = String(school.open_alloc_seats_display || "").trim();
  if (!disp) return false;
  // Display-only figures that are clearly numeric (not prose notes)
  return /^\d[\d,.\s]*$/.test(disp);
}

/** @deprecated Use hasStatedOpenSeatQuota — kept for call sites that meant “listable open seats”. */
export function hasOpenCatchmentAccess(school) {
  return hasStatedOpenSeatQuota(school);
}

export function schoolQualifiesOpenToAll(school) {
  const cat = String(school?.catchment_category || "")
    .trim()
    .toLowerCase();
  if (cat === "open") return true;
  if (cat === "both" && hasStatedOpenSeatQuota(school)) return true;
  return false;
}

/**
 * Geographically open but faith-ranked (e.g. Catholic grammars).
 * Used for subtle Open To All list styling — not a catchment type.
 */
export function isFaithPrioritySchool(school) {
  const rel = String(school?.religious_affiliation || "")
    .trim()
    .toLowerCase();
  if (!rel || rel === "none") return false;
  return rel.includes("catholic");
}

/** A dash in the seat display is an empty count, not a number of places. */
export function statedOpenSeatLabel(school) {
  const raw = String(
    school?.open_alloc_seats_display ||
      (school?.open_alloc_seats != null && school.open_alloc_seats !== ""
        ? school.open_alloc_seats
        : "")
  ).trim();
  if (!raw || raw === "—" || raw === "–" || raw === "-" || raw === "−") return "";
  return raw;
}
